// import { ConsoleService } from 'ngx-etalent-core';

// const fileId = 'B8993B8F-9433-4A45-8866-B96E9E5732A8';

import('./bootstrap')
	.catch(error =>
		console.error(error)
		// ConsoleService.error(`${fileId}. ${error}`)
	);
